var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "ui-title" }, [_vm._v("Enter new password")]),
      _vm._v(" "),
      _c(
        "ui-form",
        {
          attrs: { "is-processing": _vm.isProcessing, valid: _vm.formValid },
          on: {
            "update:valid": function ($event) {
              _vm.formValid = $event
            },
            submit: _vm.resetPassword,
          },
        },
        [
          _c("ui-input", {
            attrs: {
              autocomplete: "new-password",
              label: "Password",
              minlength: "8",
              required: "",
              type: "password",
            },
            model: {
              value: _vm.password,
              callback: function ($$v) {
                _vm.password = $$v
              },
              expression: "password",
            },
          }),
          _vm._v(" "),
          _c("ui-input", {
            attrs: {
              error: _vm.passwordMatch,
              autocomplete: "new-password",
              label: "Verify password",
              required: "",
              type: "password",
            },
            model: {
              value: _vm.verifyPassword,
              callback: function ($$v) {
                _vm.verifyPassword = $$v
              },
              expression: "verifyPassword",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ui-layout ui-alignment-center-right" },
            [
              _c("ui-button", {
                attrs: {
                  disabled: !_vm.formValid || _vm.isProcessing,
                  primary: "",
                  raised: "",
                  text: "Submit",
                  type: "submit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }